/**
 * 环境配置封装
 */
const env = import.meta.env.MODE
const Env = import.meta.env.VITE_APP_ENV || 'development'
const EnvConfig = {
  development: {
    baseApi: 'https://dev-api.askstarry.com',
    // subAppUrl: 'https://dev.askstarry.com/datax',
    // baseApi: 'http://192.168.0.18:8016',
    redirectUrl: 'https://dev.askstarry.com/commander'
  },
  test: {
    baseApi: 'https://dev-api.askstarry.com',
    redirectUrl: 'https://dev.askstarry.com/commander'
  },
  gamma: {
    baseApi: 'https://gamma-api.askstarry.com',
    redirectUrl: 'https://gamma.askstarry.com/commander'
  },
  production: {
    baseApi: 'https://api.askstarry.com',
    redirectUrl: 'https://askstarry.com/commander'
  }
}
export default {
  env,
  namespace: 'starryConsole',
  ...EnvConfig[Env]
}
